export function updateSearchUrl(selectedCategoryCodeName, urlSearchParams, urlKey) {
	urlSearchParams.set(urlKey, selectedCategoryCodeName);
	window.history.replaceState(null, '', '?' + urlSearchParams.toString());
}

export function getDropdownSelectedItemCodeName(dropdown) {
	return dropdown.find('.dropdown__item--selected').first().data('custom-value');
}

export function selectDropdownItem(codeName, dropdown, urlSearchParams, urlKey) {
	const dropdownItem = dropdown
		.find('.dropdown__item')
		.filter(function () {
			return $(this).data('custom-value') === codeName;
		})
		.find('.js-dropdown-link')
		.first();

	if (!dropdownItem.length) throw 'Invalid query parameter!';

	updateSearchUrl(codeName, urlSearchParams, urlKey);

	setTimeout(() => {
		dropdownItem.trigger('click').trigger('click');
	}, 500);
}
